import {
	SHARED_CONVERSATION_PREVIEW,
	SHARED_CONVERSATION_PREVIEW_PAGE,
} from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const sharedConversationPreviewRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: SHARED_CONVERSATION_PREVIEW_PAGE,
	path: SHARED_CONVERSATION_PREVIEW,
	layout: 'home',
	nav4Layout: 'expanded',
	query: ['as?', 'conversationId?', 'messageId?'],
});
